
import React from 'react';
import logoAndes from '../assets/logoAndesBlanco.png';

const LayoutHeader = ({ currentPage = 'Dashboard', onNavigate = () => {}, onLogout = () => {} }) => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [darkMode, setDarkMode] = React.useState(false);
  const handleToggleMenu = () => setMenuOpen(prev => !prev);
  const handleCloseMenu = () => setMenuOpen(false);
  const handleToggleDarkMode = () => setDarkMode(prev => !prev);
  React.useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 py-4 px-8 flex justify-between items-center sticky top-0 z-40">
      <div className="flex items-center">
        <div className="rounded-2xl bg-custom-green-700 px-4 py-2 shadow flex items-center justify-center mr-3" style={{ minWidth: 48, minHeight: 48 }}>
          <img src={logoAndes} alt="Logo AndesBPO" className="h-8 w-auto object-contain" style={{ maxWidth: 48 }} />
        </div>
        <span className="text-2xl font-bold text-gray-900">HelpDeskPro</span>
      </div>
      <nav>
        <ul className="flex space-x-6">
          <li>
            <button
              onClick={() => onNavigate('Dashboard')}
              className={`text-lg font-medium ${currentPage === 'Dashboard' ? 'text-custom-blue border-b-2 border-custom-blue' : 'text-gray-600 hover:text-gray-900'} transition-colors pb-1`}
            >
              Dashboard
            </button>
          </li>
          <li>
            <button
              onClick={() => onNavigate('Tickets')}
              className={`text-lg font-medium ${currentPage === 'Tickets' ? 'text-custom-blue border-b-2 border-custom-blue' : 'text-gray-600 hover:text-gray-900'} transition-colors pb-1`}
            >
              Tickets
            </button>
          </li>
        </ul>
      </nav>
      <div className="flex items-center space-x-4 relative">
        <button className="text-gray-600 hover:text-gray-900 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </button>
        <div className="relative">
          <button
            className="w-10 h-10 rounded-full bg-custom-blue flex items-center justify-center text-white font-semibold hover:bg-blue-700 transition-colors"
            onClick={handleToggleMenu}
            aria-label="Usuario"
          >
            JD
          </button>
          {menuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-xl shadow-lg z-50 py-2 animate-fade-in">
              <button
                className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                onClick={() => { alert('Mi Perfil'); handleCloseMenu(); }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-custom-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.657 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Mi Perfil
              </button>
              <button
                className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                onClick={() => { handleToggleDarkMode(); }}
              >
                <span className="flex items-center gap-1">
                  {darkMode ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m8.66-8.66l-.71.71M4.05 4.05l-.71.71M21 12h1M3 12H2m16.24 4.24l-.71-.71M6.34 17.66l-.71-.71" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z" />
                    </svg>
                  )}
                  Modo Oscuro
                  <span className="ml-2">{darkMode ? '✔️' : ''}</span>
                </span>
              </button>
              <button
                className="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 flex items-center gap-2"
                onClick={() => { handleCloseMenu(); onLogout(); }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7" />
                </svg>
                Salir
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default LayoutHeader;